import React from 'react';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { GrossOfFeeIcon } from '../../../GrossOfFeeIcon/GrossOfFeeIcon';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { usePerformanceReportingContext } from '../../../../context/usePerformanceReportingContext';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { PerformanceVsBenchmarkChart } from '../../../PerformanceVsBenchmarkChart/PerformanceVsBenchmarkChart';
import { usePerformanceVsBenchmark } from '../../../../hooks/usePerformanceVsBenchmark';

export const PerformanceVsBenchmarkCard = React.memo(() => {
  const { updatedAt, selectedItemName } = usePerformanceReportingContext();

  const { chartTitle } = usePerformanceVsBenchmark();

  return (
    <Card height={400} px="16" pt="12" pb="16">
      <Text variant="cardTitle" mb="12">
        {chartTitle}
        <GrossOfFeeIcon />
      </Text>

      <Box flex={1}>
        <PerformanceVsBenchmarkChart selectedItemName={selectedItemName} updatedAt={updatedAt} />
      </Box>
    </Card>
  );
});
